<template>
    <form @submit.prevent="resetPass" novalidate>
        <div
            v-if="errors.errorMessage()"
            v-html="errors.errorMessage()"
            class="form-error-message"
        ></div>
        <div
            v-if="successMessage"
            v-html="successMessage"
            class="form-success-message"
        ></div>

        <div class="form-group">
            <app-input
                :error="errors.get('email')"
                v-model="form.email"
                :label="$trans('auth.login.email')"
                :placeholder="$trans('auth.reset.email')"
            >
            </app-input>
        </div>

        <div class="form-group flex-items submit-row">
            <div class="flex-item">
                <app-button
                    :loading="loading"
                    :disabled="successMessage !== false"
                    type="submit"
                    >{{ $trans("auth.reset.reset_pass") }}</app-button
                >
            </div>
            <div class="flex-item">
                <a :href="app.links.login" class="existing-user">{{
                    $trans("auth.register.existing_user")
                }}</a>
            </div>
        </div>

        <div class="separator"></div>

        <div class="form-group">
            <div
                class="agreement-text"
                v-html="$trans('auth.terms_text')"
            ></div>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            errors: this.$api.errors(),
            loading: false,
            successMessage: false,
            form: {
                email: ""
            }
        };
    },
    methods: {
        async resetPass() {
            this.loading = true;

            this.errors.clear();
            const response = await this.$api.post(
                "auth/password-reset",
                this.form
            );
            this.loading = false;

            if (response.hasErrors()) {
                this.errors = response.errors();
                return;
            }

            this.form.email = "";

            if (response.data().message) {
                this.successMessage = response.data().message;
            }

            if (response.data().redirect) {
                setTimeout(() => {
                    window.location.href = response.data().redirect;
                }, 2000);
            }
        }
    }
};
</script>
